var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _c(
        "div",
        { staticClass: "grid grid-cols-1 md:grid-cols-2 gap-0" },
        [
          _c("form-item", {
            attrs: { label: "Phone Number" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Input", {
                      attrs: {
                        placeholder: "Phone Number",
                        error:
                          _vm.$v.phone_number.$dirty &&
                          !_vm.$v.phone_number.required
                      },
                      model: {
                        value: _vm.phone_number,
                        callback: function($$v) {
                          _vm.phone_number = $$v
                        },
                        expression: "phone_number"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.phone_number.$dirty &&
                        !_vm.$v.phone_number.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill your phone number." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Local Conference" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Input", {
                      attrs: {
                        placeholder: "Local Conference",
                        error:
                          _vm.$v.missions.$dirty && !_vm.$v.missions.required
                      },
                      model: {
                        value: _vm.missions,
                        callback: function($$v) {
                          _vm.missions = $$v
                        },
                        expression: "missions"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.missions.$dirty && !_vm.$v.missions.required
                          ? _c("text-error", {
                              attrs: {
                                text: "Please fill your local conference."
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 md:grid-cols-2 gap-0" },
        [
          _c("form-item", {
            attrs: { label: "Church" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Input", {
                      attrs: {
                        placeholder: "Church",
                        error: _vm.$v.church.$dirty && !_vm.$v.church.required
                      },
                      model: {
                        value: _vm.church,
                        callback: function($$v) {
                          _vm.church = $$v
                        },
                        expression: "church"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.church.$dirty && !_vm.$v.church.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill your church." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Monetize Choice" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "el-select",
                      {
                        staticClass: "w-full",
                        class:
                          _vm.$v.monetize_choice.$dirty &&
                          _vm.$v.monetize_choice.$anyError
                            ? "border-red-500"
                            : "",
                        attrs: { filterable: "", placeholder: "Select" },
                        model: {
                          value: _vm.monetize_choice,
                          callback: function($$v) {
                            _vm.monetize_choice = $$v
                          },
                          expression: "monetize_choice"
                        }
                      },
                      _vm._l(_vm.monetizeOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.monetize_choice.$dirty &&
                        !_vm.$v.monetize_choice.required
                          ? _c("text-error", {
                              attrs: {
                                text: "Please choose a monetize option."
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("form-item", {
        attrs: {
          label: "Links",
          info: "Portfolio, social media, or demo links (URLs)."
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("TextArea", {
                  attrs: {
                    placeholder: "Links",
                    error: _vm.$v.links.$dirty && !_vm.$v.links.required,
                    rows: "2"
                  },
                  model: {
                    value: _vm.links,
                    callback: function($$v) {
                      _vm.links = $$v
                    },
                    expression: "links"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.links.$dirty && !_vm.$v.links.required
                      ? _c("text-error", {
                          attrs: { text: "Please fill your links." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Self Introduction" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("TextArea", {
                  attrs: {
                    placeholder: "Tell us about yourself",
                    error:
                      _vm.$v.self_introduction.$dirty &&
                      !_vm.$v.self_introduction.required,
                    rows: "4"
                  },
                  model: {
                    value: _vm.self_introduction,
                    callback: function($$v) {
                      _vm.self_introduction = $$v
                    },
                    expression: "self_introduction"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.self_introduction.$dirty &&
                    !_vm.$v.self_introduction.required
                      ? _c("text-error", {
                          attrs: { text: "Please fill your self introduction." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "px-4 py-4" }, [
        _c("label", { staticClass: "flex items-start" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.legal_accepted,
                expression: "legal_accepted"
              }
            ],
            staticClass: "mt-1 mr-2",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.legal_accepted)
                ? _vm._i(_vm.legal_accepted, null) > -1
                : _vm.legal_accepted
            },
            on: {
              change: function($event) {
                var $$a = _vm.legal_accepted,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.legal_accepted = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.legal_accepted = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.legal_accepted = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col pt-2" },
          [
            _vm.$v.legal_accepted.$dirty && !_vm.$v.legal_accepted.checked
              ? _c("text-error", {
                  attrs: { text: "You must accept the Terms and Conditions." }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-sm text-gray-700" }, [
      _vm._v("\n        I accept the "),
      _c(
        "a",
        {
          staticClass: "underline",
          attrs: {
            href: "https://musicverse.org/terms-and-conditions",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Terms and Conditions")]
      ),
      _vm._v(" and confirm the information provided is accurate.\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fbd20a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fbd20a5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormArtistApplication.vue
// module id = null
// module chunks = 